import {action, observable, makeObservable} from "mobx";
import {TopicLayerConfiguration} from "../../config/topic-configuration";

export class CompareStore {
    enabled: boolean;
    layers = observable.map<string, number[]>();
    layersLeading: TopicLayerConfiguration[];
    layersTrailing: TopicLayerConfiguration[];
    matrixSelect: string[];
    matrixSelectTrailing: string[];
    constructor() {
        makeObservable(this, {
            enabled: observable,
            layers: observable,
            layersLeading: observable,
            layersTrailing: observable,
            matrixSelect: observable,
            matrixSelectTrailing: observable,

            setEnabled: action,
            setLayersLeading: action,
            setLayers: action,
            setLayersTrailing: action,
            setMatrixSelect: action,
            setMatrixSelectTrailing: action
        });
        this.setEnabled(false);
        this.setLayersLeading([]);
    }
    setEnabled(enabled: boolean) {
        this.enabled = enabled;
    }
    setLayersLeading(layersLeading: TopicLayerConfiguration[]) {
        this.layersLeading = layersLeading;
    }
    setLayers(layers: Map<string, number[]>) {
        this.layers = observable.map<string, number[]>();
        layers.forEach((layerIds, key)=>{
            this.layers.set(key, layerIds);
        });
    }
    setLayersTrailing(layersTrailing: TopicLayerConfiguration[]){
        this.layersTrailing = layersTrailing;
    }
    setMatrixSelect(matrixSelect: string[]){
        this.matrixSelect = matrixSelect;
    }
    setMatrixSelectTrailing(matrixSelectTrailing: string[]){
        this.matrixSelectTrailing = matrixSelectTrailing;
    }
}
